import config from '@bymason/runtime-config';

export function getLegacyEndpointTemplate(path: string) {
  return `${config.ApiDomainUrlLegacy}/api/${path.startsWith('/') ? path.substring(1) : path}`;
}
